"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jwtDecode2 = _interopRequireDefault(require("jwt-decode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const decode = jwt => {
  try {
    var _jwtDecode;

    return (_jwtDecode = (0, _jwtDecode2.default)(jwt)) === null || _jwtDecode === void 0 ? void 0 : _jwtDecode.data;
  } catch {
    return undefined;
  }
};

var _default = {
  decode
};
exports.default = _default;
//# sourceMappingURL=tokenHandler.js.map